import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-policy-page',
  templateUrl: './policy-page.component.html',
  styleUrls: ['./policy-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolicyPageComponent {
  private readonly router = inject(Router);

  readonly APP_VERSION = environment.appVersion;

  close() {
    this.router.navigate(['/']);
  }
}
